module.exports = __webpack_public_path__ + "static/dataRecovery-1441f863a8e7c83faeeb2f46f9705200.jpg";